import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '@/pages/shared/base-query-auth';
import { runMutationOnce } from '@/pages/shared/rtk-query-helpers';

export const updateMetadataApi = createApi({
    reducerPath: 'updateMetadataApi',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        // A POST search for the details of an explicit id list, not a cacheable read.
        getDocumentsDetails: builder.mutation({
            query: (documentIds) => ({
                url: '/api/document/detailsList',
                method: 'POST',
                body: documentIds,
            }),
        }),
        updateDocumentsDetailsList: builder.mutation({
            query: (model) => ({
                url: '/api/document/updateList',
                method: 'POST',
                body: model,
            }),
        }),
        // `fetchBaseQuery` passes FormData through untouched and lets the browser set the
        // multipart boundary, so no Content-Type may be declared here.
        importMetadata: builder.mutation({
            query: ({ formData, link }) => ({
                url: `/api/importMetadata/${link}`,
                method: 'POST',
                body: formData,
            }),
        }),
    }),
});

export const { useImportMetadataMutation } = updateMetadataApi;

/**
 * Runs an `updateMetadataApi` endpoint once and clears its tracked entry.
 */
export const runUpdateMetadataMutation = (dispatch, endpointName, arg) =>
    runMutationOnce(dispatch, updateMetadataApi.endpoints[endpointName], arg);

export default updateMetadataApi;
